module.exports = __webpack_public_path__ + "img/14.5fc0a69c.jpg";